import { Button } from 'antd';

const BtnSimpl = ({ cursor_, backgroundColor_, fontSize_, padding_, disabledColor_, title_, disabled_, float_, className_,  borderRadius_, border_, width_, margin_, buttonText_, color_, boldColor_, height_, position_, top_, onClick_, left_ ,htmlType_, marginTop_, prefix_, suffix_}) => {

    const buttonStyle = {  
        title: title_, 
        width: width_,
        margin: margin_,
        padding: padding_,
        // backgroundImage: disabled_ || backgroundColor_,
        fontWeight: boldColor_,
        height: height_,
        position: position_,
        top: top_,
        border: border_,
        borderRadius: borderRadius_,
        cursor: cursor_ || 'pointer',
        backgroundColor: disabled_ || backgroundColor_,
        color: disabled_ ? disabledColor_ : color_,
        float: float_,
        left: left_,
        fontSize: fontSize_,
        marginTop:marginTop_,
    };

    return (
        <div>
             <Button
            className={className_}
            htmlType={htmlType_}
            style={buttonStyle}
            disabled={disabled_}
            onClick={onClick_}
        >
            {prefix_ && <span style={{ marginRight: '8px', fontSize: "18px", }}>{prefix_}</span>}
            {buttonText_}
             {suffix_ && <span style={{ marginRight: '', fontSize: "", }}>{suffix_}</span>}
        </Button>
        </div>
    );
};

export default BtnSimpl;






